import React, { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import AthleteLayout from "../common/AthleteLayout";
import { AthleteHeader } from "../common/AthleteHeader";
import { useAthleteAuthContext } from "../login/useAthleteAuthContext";
import API_URL from "../../api/API";
import { useParams } from "react-router-dom";

export const AthleteWarmupRoutinePhases = () => {
  const { athlete } = useAthleteAuthContext();
  const { product_id } = useParams();
  const navigate = useNavigate();
  const location = useLocation();

  // product was passed from previous page
  const productFromState = location.state?.product_basic;

  console.log("State Found: ", location.state);

  const [product, setProduct] = useState(productFromState || null);
  const [phases, setPhases] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    // CASE 0 — Coming back from exercises page
    if (location.state?.product_basic && location.state?.phase) {
      console.log("Returning back → skipping fetch");

      setProduct(location.state.product_basic);
      setPhases(location.state.product_basic.warmup_template || []);
      setIsLoading(false);
      return;
    }

    // CASE 1 — Full product already passed (has warmup_template)
    if (productFromState && productFromState.warmup_template?.length > 0) {
      console.log("Using product from state (has phases)");

      setProduct(productFromState);
      setPhases(productFromState.warmup_template);
      setIsLoading(false);
      return;
    }

    // CASE 2 — productBasic exists but without warmup_template → must fetch
    // CASE 3 — No state at all → must fetch
    const fetchProductDetail = async () => {
      try {
        const productId = productFromState?._id || product_id;

        const response = await fetch(
          `${API_URL.FRONTEND_ATHLETE_PURCHASED_SPEED_PRODUCT_DETAIL}${athlete.id}/${productId}`,
          {
            headers: {
              Authorization: `Bearer ${athlete.token}`,
            },
          },
        );

        const json = await response.json();

        if (!response.ok) {
          setError(json.message || "Failed to load");
          return;
        }

        setProduct(json.data);
        setPhases(json.data.warmup_template || []);
      } catch (err) {
        setError(err.message);
      } finally {
        setIsLoading(false);
      }
    };

    fetchProductDetail();
  }, []);

  const handleAmaxSpeedWorkoutClick = () => {
    navigate(`/athlete/speed-product/speed-workout/${product_id}`, {
      state: {
        speedTrainingTemplate: product.speed_training_template,
        product_basic: product, // for back navigation
      },
    });
  };

  return (
    <AthleteLayout>
      {/* HEADER (kept same, even though date is irrelevant now) */}
      <div className="text-black h-full bg-white">
        <div className="pb-3 mb-3 w-full max-w-2xl mx-auto flex flex-row justify-center items-center gap-10 px-5">
          <p className="w-full py-3 text-black text-xl line-clamp-2 leading-tight text-center border-b border-black/30">
            {product?.title || "Product"}
          </p>
        </div>

        <div className="flex-1 overflow-y-auto w-full max-w-2xl mx-auto">
          <div>
            <div className="px-5 mb-4">
              <div className="bg-[#f5f4f4] rounded-2xl flex justify-between gap-8 px-4 py-4">
                <button className="text-black text-sm xs:text-base">
                  Warmup
                </button>
                <button
                  onClick={handleAmaxSpeedWorkoutClick}
                  className="text-lightSmock text-sm xs:text-base"
                >
                  Workout
                </button>
              </div>
            </div>

            {isLoading ? (
  <div className="flex flex-col items-center justify-center py-20 gap-3">
    <div className="w-8 h-8 border-4 border-black/20 border-t-black rounded-full animate-spin"></div>
    <p className="text-black/50 text-sm">Loading...</p>
  </div>
) : error ? (
              <div className="bg-red-100 text-red-500 p-3 rounded mb-4">
                {error}
              </div>
            ) : (
              <div className="space-y-[15px] px-5">
                {phases.map((item) => (
                  <button
                    key={item.phase_id}
                    onClick={() =>
                      item.type !== "RestPhase" && product
                        ? navigate(
                            `/athlete/speed-product/warmup-routine-phase-exercises/${product._id}`,
                            {
                              state: { phase: item, product_basic: product },
                            },
                          )
                        : null
                    }
                    className={`w-full p-[14px] border border-black/90 bg-transparent rounded-xl hover:bg-grayish/10 transition text-start
              ${item.type === "RestPhase" ? "cursor-default" : "hover:bg-grayish/10"}`}
                  >
                    <p className="text-black text-base xs:text-lg font-medium">
                      {item.title}
                    </p>
                    {item.type === "RestPhase" && (
                      <div className="mt-1 text-sm text-grayish">
                        {item.rest_duration && (
                          <p className="inline-block">
                            ⏱
                            <span className="ml-0.5 text-sm xs:text-base font-medium">
                              {item.rest_duration}
                            </span>
                          </p>
                        )}
                        {item.rest_notes && (
                          <p className="block text-sm xs:text-base font-medium italic">
                            {item.rest_notes}
                          </p>
                        )}
                      </div>
                    )}
                  </button>
                ))}
              </div>
            )}
          </div>
        </div>
      </div>
    </AthleteLayout>
  );
};
